import { Injectable } from "@angular/core";
import { Constants } from './constants';

interface QueryParams {
  utm_source: string,
  utm_medium: string,
  utm_campaign: string
};

@Injectable()
export class UtmService {
  utmSource: string = '';
  queryParams: QueryParams = { utm_source: '', utm_medium: '', utm_campaign: '' };

  setUtmSource(source): void {
    if (source) {
      this.utmSource = source;
    }
  }

  setParams(queryParams): void {
    this.queryParams = queryParams;
  }

  getQueryParams(): QueryParams {
    return this.queryParams;
  }

  getFormPath(): string {
    let path = '';
    switch(this.utmSource) {
      case 'facebookAds':
      case 'facebook':
      case 'instagram':
      case 'linkedin':
        path = Constants.formRedirectFacebookAdsUrl;
        break;
      case 'newsletter':
      default:
        path = Constants.formGenericUrl;
        break;     
    }
    return path;
  }
  getLevel1FormPath(): string {
    let path = '';
    switch(this.utmSource) {
      case 'facebookAds':
        path = Constants.formFacebookAdsLevel1Url;
        break;
      case 'newsletter':
        path = Constants.formNewsletterLevel1Url;
        break;
      default:
        path = Constants.formGenericLevel1Url;
        break;     
    }
    return path;
  }

  getLevel2FormPath(): string {
    let path = '';
    switch(this.utmSource) {
      case 'facebookAds':
        path = Constants.formFacebookAdsLevel2Url;
        break;
      case 'newsletter':
        path = Constants.formNewsletterLevel2Url;
        break;
      default:
        path = Constants.formGenericLevel2Url;
        break;     
    }
    return path;
  }

  getLevel3FormPath(): string {
    let path = '';
    switch(this.utmSource) {
      case 'facebookAds':
        path = Constants.formFacebookAdsLevel3Url;
        break;
      case 'newsletter':
        path = Constants.formNewsletterLevel3Url;
        break;
      default:
        path = Constants.formGenericLevel3Url;
        break;     
    }
    return path;
  }
}
